import { render, staticRenderFns } from "./InspectionContractRecord.vue?vue&type=template&id=1cc8285e&scoped=true"
import script from "./InspectionContractRecord.vue?vue&type=script&lang=js"
export * from "./InspectionContractRecord.vue?vue&type=script&lang=js"
import style0 from "./InspectionContractRecord.vue?vue&type=style&index=0&id=1cc8285e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc8285e",
  null
  
)

export default component.exports